import De from "../../assets/images/flags/de.svg?react";

export default De;
